import CollapsibleCard from './collapsible_card'

export default CollapsibleCard
